export default __webpack_public_path__ + "static/media/team.e97d6698.svg";